import React, { useState, useEffect } from "react";
import productos from "../../hooks/productos.json";
import { useLocation, Link } from "react-router-dom";
import DocumentMeta from 'react-document-meta';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import './Zoom.css'
import './Producto.css'

const Producto = () => {

    const [data, setData] = useState({});
    const [elements, setelements] = useState([]);
    const [docTypes, setDocTypes] = useState([]);
    const [meta, setMeta] = useState({});

    const { pathname } = useLocation();

    const options = {
        loop: true,
        margin: 30,
        dots: false,
        nav: true,
        navText: [
            "<i class='bx bxs-chevron-left'></i>",
            "<i class='bx bxs-chevron-right'></i>"
        ],
        addClassActive: true,
        autoplay: true,
        autoplayHoverPause: true,
        autoplayTimeout: 8500,
        smartSpeed: 250,
        items: 1,

    };

    const options_rel = {
        loop: true,
        margin: 10,
        dots: true,
        nav: true,
        navText: [
            "<i class='bx bxs-chevron-left'></i>",
            "<i class='bx bxs-chevron-right'></i>"
        ],
        addClassActive: true,
        autoplay: true,
        autoplayHoverPause: true,
        autoplayTimeout: 3000,
        smartSpeed: 250,
        items: 1,
    };

    const zoomImage = (e) => {
        const newElement = React.createElement('div', {
            key: 'ele' + new Date().getTime(),
            className: 'zoomBackground zoom',
            onClick: () => {
                document.querySelectorAll('.zoom').forEach((zoom) => zoom.remove())
            }
        });
        setelements(elements => [...elements, newElement]);

        const newElement2 = React.createElement('img', {
            key: 'ele' + new Date().getTime() + 1,
            src: e.target.getAttribute('src'),
            className: 'zoomIt zoom',
            onClick: () => {
                document.querySelectorAll('.zoom').forEach((zoom) => zoom.remove())
            }
        });

        setelements(elements => [...elements, newElement2]);

        const newElement3 = React.createElement('div', {
            key: 'ele' + new Date().getTime() + 2,
            src: e.target.getAttribute('src'),
            className: 'zoomClose zoom',
            onClick: () => {
                document.querySelectorAll('.zoom').forEach((zoom) => zoom.remove())
            }
        });

        setelements(elements => [...elements, newElement3]);

        const newElement4 = React.createElement('div', {
            key: 'ele' + new Date().getTime() + 3,
            src: e.target.getAttribute('src'),
            className: 'zoomClose2 zoom',
            onClick: () => {
                document.querySelectorAll('.zoom').forEach((zoom) => zoom.remove())
            }
        });

        setelements(elements => [...elements, newElement4]);

    }

    useEffect(() => {

        window.scrollTo(0, 150);

        var data = productos.find(producto => producto.id == pathname.split('/').pop());

        setMeta({
            title: data.title,
            description: data.metadata.description,
            canonical: 'https://' + window.location.host + pathname,
            meta: {
                charset: 'utf-8',
                name: {
                    keywords: data.metadata.tags.join(',')
                }
            }
        });

        if (data.related && data.related.length > 0) {

            data.related = data.related.map((related) => {
                return productos.find(producto => producto.id == related.id);
            });

        }

        setData({ ...data, gallery: null });
        if (data.documents) {
            setDocTypes(data.documents.reduce((acc, doc) => {
                if (!acc.includes(doc.type)) {
                    acc.push(doc.type);
                }
                return acc;
            }, []));
        }
        setTimeout(() => {
            var ndata = productos.find(producto => producto.id == pathname.split('/').pop());
            setData({ ...data, gallery: ndata.gallery });
        }, 500);


    }, [pathname]);

    return (<DocumentMeta {...meta}>


        <div className="page-title-area ptb-100">
            <div className="container">
                <div className="page-title-content">
                    <h1>{data.title || 'Producto'}</h1>
                    <p className="text-info">{data.type || ''}</p>
                </div>
            </div>
            <div className="bg-image">
                <img src={process.env.PUBLIC_URL + "/assets/img/banner/title.jpg"} alt="" />
            </div>
        </div>


        <div className="project-details-area pt-100 pb-70">
            <div className="container">
                <div style={{ alignItems: 'center' }} className="row items-center">
                    <div className="col-lg-1 col-md-12">
                    </div>
                    <div className="col-lg-4 col-md-12">
                        <div className="project-details-desc mb-30 flex">
                            {/*CAMBIAR ICONO POR ESFERITA*/ }
                            {data.gallery && <OwlCarousel id="project-details-slider" className="owl-carousel owl-theme" {...options}>
                                {data.gallery.map((img, index) => (
                                    <div className="image justify-content-middle" key={`dv_${index}`} onClick={zoomImage}>
                                        <img src={process.env.PUBLIC_URL + "/assets/img/productos/" + img.image} key={index} alt="" />
                                    </div>
                                ))}
                            </OwlCarousel>

                            }
                            {
                                elements
                            }

                        </div>
                    </div>
                    <div className="col-lg-1 col-md-12">
                    </div>
                    <div className="col-lg-6 col-md-12">
                        <aside className="widget-area">
                            <div className="widget">
                                {/*CAMBIAR COLOR DE FONDO*/}
                                <h3>{data.title}</h3>
                                <p className="text-primary">{data.subTitle}</p>
                                {data.content && <p>{data.content}</p>}

                                {data.features && data.features.map((feature, index) => (
                                    <div className="content-list" >
                                        <i className="bx bxs-right-arrow" />
                                        <div>
                                            <h3>{feature}</h3>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </aside>
                    </div>
                </div>
                <div className="row">
                    {data.documents && (
                        <div className="col">
                            <h2 className="text-secondary mt-5">Documentación técnica</h2>
                            <hr />
                            <div className="panel-group mb-30" id="accordion">
                                <div className="row">
                                    <div className="col-lg-12">
                                        {
                                            docTypes.map((docType, index) => (
                                                <div className="panel" key={`dvs_${index}`}>
                                                    <div className="panel-heading">
                                                        <h4 className="panel-title">
                                                            <a className="collapsed" data-toggle="collapse" href={"#collapse" + index} aria-expanded="false">
                                                                {docType}
                                                            </a>
                                                        </h4>
                                                    </div>
                                                    <div id={"collapse" + index} className="panel-collapse collapse" data-parent="#accordion">{
                                                        data.documents.filter(doc => doc.type == docType).map((doc, index) => (
                                                            <div className="panel-body" key={`dvd_${index}`}>
                                                                <div className="row align-items-center">
                                                                    <div className="col-6">
                                                                        <p>{doc.title}</p>
                                                                    </div>
                                                                    <div className="col text-center">
                                                                        <p>{doc.date}</p>
                                                                    </div>
                                                                    <div className="col col-lg-4">
                                                                        <div className="text-center">
                                                                            {doc.download && (
                                                                                <a href={process.env.PUBLIC_URL + "/assets/docs/" + doc.type.toLowerCase() + "/" + doc.href} target="_blank" className="btn btn-primary" rel="noreferrer">Descargar</a>
                                                                            )}
                                                                            {!doc.download && (
                                                                                <a href={doc.href} target="_blank" className="btn btn-success" rel="noreferrer">Abrir</a>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}{/* 
                    {data.related && data.related.length > 0 && (
                        <div className="col-lg-4 service-section-two">
                            <h5 className="text-secondary mt-5">Productos relacionados</h5>
                            <OwlCarousel id="related-slider" className="owl-carousel owl-theme" {...options_rel}>
                                {data.related.map((related, index) => (
                                    <div className="item-single">
                                        <div className="image">
                                            <Link to={'/productos/' + related.id}>
                                                <img src={process.env.PUBLIC_URL + "/assets/img/productos/" + related.gallery[0].image} key={index} alt="" />
                                            </Link>
                                        </div>
                                        <div className="content">
                                            <h4 ><Link className="related-product-title" to={'/productos/' + related.id}>{related.title}</Link></h4>
                                            <p>{related.subTitle}</p>
                                            <div className="cta-btn">
                                                <Link to={'/productos/' + related.id} className="btn-text">Ver más...</Link>
                                            </div>
                                        </div>
                                        <div className="spacer"></div>
                                    </div>
                                ))}
                            </OwlCarousel>
                        </div>
                    )
                    } */}
                </div>
            </div >
        </div >

    </DocumentMeta>
    );
}

export default Producto;